import styled from 'styled-components';

export default styled.main`
  width: 100%;
  * {
    line-height: 0;
  }
`;
